export var config = {
  employerTermsUrl: 'https://www.restworld.it/condizioni_employer.pdf',
  workerTermsUrl: 'https://www.restworld.it/condizioni_worker_04.07.2022.pdf',
  restworldPrivacyUrl: 'https://www.restworld.it/legale/privacy-policy',
  restworldCookiePolicyUrl: 'https://www.restworld.it/legale/cookie-policy',
  accomodationPartnerUrl: 'https://housinganywhere.com/it/register/8474',
  learningPartnerUrl: 'https://ac.academia.tv/restworld',
  hireWithRestworldTypeformUrl: 'https://restworld.typeform.com/to/oSu5piK6'
};